import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';

@Injectable({
  providedIn: 'root'
})
export class PublicUserSessionService {

  private baseUrl: string = this.config.publicBaseUrl;
  private static readonly path: string = 'publicusersession/';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {}

  setIsAllowAccessContent$(isAllow: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + PublicUserSessionService.path + 'setallowaccesscontent/'+isAllow);
  }

  getIsAllowAccessContent$(): Observable<string> {
    return this.http.get<string>(this.baseUrl + PublicUserSessionService.path + 'getallowaccesscontent');
  }

  clearSession$(): Observable<any> {
    return this.http.get<any>(this.baseUrl + PublicUserSessionService.path + 'clearsession');
  }
}
